export const getLinkedinUrl = (socialMediaUrls:any) => {
  let linkedinUrl = '';
  let linkedinProfies = [];
  if(socialMediaUrls && socialMediaUrls.length){
    linkedinProfies = socialMediaUrls?.find((item: any) => item.name === "LinkedIn")
  }
  if(linkedinProfies?.length > 1){
   linkedinUrl = linkedinProfies.find((item: any) => item.source === "core")?.url;
  }
  else{
    linkedinUrl = linkedinProfies?.url;
  }
  return linkedinUrl;
}

export const getContactDetails = (email: any, mobile: any) => {
  let contactDetails = {
    email: '',
    phone: '',
  };
  if(email && email.id){
    contactDetails.email = email.id;
  }
  if(mobile && mobile.number){
    contactDetails.phone = mobile.number;
  }
  return contactDetails;
}

export const convertDateFormat = (inputDate: any) => {
  const dateParts = inputDate.split('T')[0].split('-');
  const year = parseInt(dateParts[0]);
  const month = parseInt(dateParts[1]) - 1;
  const day = parseInt(dateParts[2]);
  const dateObj: any = new Date(year, month, day);

  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  const formattedDate: any = dateObj.toLocaleDateString('en-US', options);

  return formattedDate;
}

export const getHealthApiPayload = (status: number, queryObject: any, startTime: Date, recruiterId: any, pageName: string) => {
  let  HTMLresponseEnd = 0;
  let domInteractiveTime = 0;
  let serverResponseTime = 0;
  let endDate = Date.now();

  if (window.performance && window.performance.getEntriesByType) {
    const entries = window.performance.getEntriesByType('navigation');
    if (entries.length > 0) {
        const navTiming = entries[0] as PerformanceNavigationTiming;
        serverResponseTime =  navTiming.responseEnd - navTiming.requestStart;
        serverResponseTime = Math.round(((serverResponseTime / 1000) + Number.EPSILON) * 100) / 100;
        if (navTiming.loadEventEnd) {
            HTMLresponseEnd = navTiming.responseEnd
            domInteractiveTime = navTiming.domInteractive
        }
    }
}


  const timeDiff = (endDate - startTime.getTime())/1000;
  let startTime_ = new Date(startTime).getTime()
  return {
    query: JSON.stringify(queryObject),
    pageStatus : status,
    pageLoadStartTime : `${new Date(startTime_ - HTMLresponseEnd)}`,
    pageLoadEndTime : `${new Date(endDate)}`,
    pageName: pageName,
    pageURL: window.location.href,
    subUID : recruiterId,
    pageLoadTime : timeDiff,
    timeOfInteraction: domInteractiveTime/1000,
    totalLoadTime: ((endDate - startTime_ + HTMLresponseEnd) / 1000).toFixed(2),
    serverResponseTime: serverResponseTime
  }
 
}


